'use client';
import React, {ChangeEvent, useCallback, useEffect, useLayoutEffect, useState} from 'react';
import {usePathname, useRouter} from 'next/navigation';
import {switchTheme} from '@/app/utils/themeSwitch';
import {FOOTER_PAGES, HashMapPathName} from '@/app/config';
import {SRewardAnimation} from "@/app/_components/Coin/SRewardAnimation";
import CoinLabel from "@/app/_components/Coin/CoinLabel";
import {RewardType} from "@/Core/Reward/RewardInfo";
import {useAppDispatch, useAppSelector} from "@/app/storeHooks";
import {selectAccountInfo, updateAccountInfo} from "@/app/(pages)/account/accountSlice";
import {selectUserInfo, SET_REWARD_TYPE} from "@/app/userSlice";
import {getLocalRewardType, setLocalRewardType} from "@/app/utils/auth";
import Link from "next/link";
import ChannelMgr from "@/Fwk/Channel/ChannelMgr";
import styles from './Header.module.css';
import {selectMainState} from "@/app/MainSlice";

export default function Header() {
    const router = useRouter();
    const pathname = usePathname();
    const userInfo = useAppSelector(selectUserInfo);
    const account = useAppSelector(selectAccountInfo);
    const dispatch = useAppDispatch();
    // const {rewardType} = useAppSelector(selectMainState);

    const percent = Math.floor(account.info.userVipExp / (account.info.userNextVipExp > 0 ? account.info.userNextVipExp : account.info.userVipExp ) * 100) || 0;

    const [shrink, setShrink] = useState(false);
    const [fade, setFade] = useState(false);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        SRewardAnimation.checkInitCoin();
    }, []);

    useEffect(() => {
        if (!userInfo.firstRequestUserInfo) {
            const rewardType = userInfo.rewardType;
            if (rewardType === RewardType.GC) {
                setChecked(false)
                switchTheme('GC')
            }
            if (rewardType === RewardType.SC) {
                setChecked(true)
                switchTheme('SC')
            }
            setLocalRewardType(rewardType)
        }
    }, [userInfo.rewardType, userInfo.firstRequestUserInfo])

    const onClickSwitchBtn = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setChecked(true)
            switchTheme('SC')
            setLocalRewardType(RewardType.SC);
            dispatch(SET_REWARD_TYPE(RewardType.SC));
        } else {
            setChecked(false)
            switchTheme('GC')
            setLocalRewardType(RewardType.GC)
            dispatch(SET_REWARD_TYPE(RewardType.GC));
        }
    };

    // 避免在渲染期间直接返回 null
    if (!HashMapPathName(FOOTER_PAGES, pathname)) {
        return <></>;  // 代替返回 null，可以返回一个空的元素或不渲染任何东西
    }

    return (
        <>
            <header className={`${styles.header} ${fade ? styles.fade : ''} ${shrink ? styles.shrink : ''}`}>
                <div className={`${styles.header_wrapper} center-space-between`}>
                    <Link href={`/${ChannelMgr.getQid}`} className={styles.header_logoa}>
                        <img className={styles.header_logo} src="/img/logo.webp" alt=""/>
                    </Link>

                    <div className={`${styles.header_gold_wrapper}`}>
                        <CoinLabel
                            type={userInfo.rewardType}
                            isShowAdd={true}
                            click={() => {
                                router.push('/store');
                            }}
                        />
                    </div>

                    <div id="guideStep1_2" className={`${styles.hd_border} ${styles.header_switch_wrapper}`}>
                        <label className={`${styles.switch}`}>
                            <input
                                type="checkbox"
                                checked={checked}
                                // checked={true}
                                id="switch-input"
                                onChange={onClickSwitchBtn}
                            />
                            <span className={`${styles.slider}`}></span>
                        </label>
                    </div>

                    <div className={`${styles.header_vip_wrapper}`} onClick={() => {
                        router.push('/account/member')
                    }}>
                        <div
                            className={styles.vip_circle}
                            // @ts-ignore
                            style={{'--progress': `${percent}%`, '--last': '0%'}}
                        >
                            <div className={`${styles.circle_num}`}>
                                {account?.info?.userVipName && <img src={`/img/vip_icon_slices/${account.info.userVipName.trim().toLowerCase()}.webp`}
                                      alt=""/>}
                            </div>
                            {/*<div className={`${styles.vip_content} h-v-center ft-900`}>*/}
                            {/*    <img src="/img/img_vip.webp" alt=""/>*/}
                            {/*    <p style={{fontSize: '.22rem'}}>{percent}%</p>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </header>

            {HashMapPathName(FOOTER_PAGES, pathname) && pathname !== "/" && <div className="header_panel"></div>}
        </>
    )
}
